import React, { useEffect, useState } from "react";
import { GetCustomSettingTemplate } from "../service/authApi";
import logo from "../assets/image/logo.png";

const TermsCondition = () => {
  const [modalContent, setModalContent] = useState({
    termsCondition: "",
  });
  const [error, setError] = useState(null);
  const fetchModalData = async () => {
    try {
      const data = await GetCustomSettingTemplate();

      if (data.status) {
        setModalContent({
          termsCondition:
            data.data.termsCondition ||
            "Default body content if API fails to provide.",
        });
      } else {
        setError(data.data.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message || "An error occurred while fetching data");
    }
  };
  useEffect(() => {
    fetchModalData();
  }, []);
  return (
    <>
      {" "}
      <div className="logo">
        <img src={logo} alt="" />
      </div>
      <div className="p-5">
        <div className="">
          <h1 align="center">
            <b>TERM OF SERVICE FOR EXCEL YOUR REVENUE</b>
          </h1>
          <h3 align="center">VERSION #2</h3>
          <span>
            <b>
              {" "}
              PLEASE READ THIS AGREEMENT CAREFULLY BEFORE USING THIS SERVICE
            </b>
          </span>
          <div
            dangerouslySetInnerHTML={{
              __html: modalContent.termsCondition,
            }}
          ></div>
        </div>{" "}
      </div>
    </>
  );
};

export default TermsCondition;
